import { render, staticRenderFns } from "./Responsibilities.vue?vue&type=template&id=5615bd5e"
import script from "./Responsibilities.vue?vue&type=script&lang=js"
export * from "./Responsibilities.vue?vue&type=script&lang=js"
import style0 from "./Responsibilities.vue?vue&type=style&index=0&id=5615bd5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports